<script lang="ts">
import {defineComponent, ref} from '@vue/composition-api'

export default defineComponent({
  name: 'RegistrationCard',
  setup() {
    const isHovering = ref(false)
    return {
      isHovering,
    }
  },
})
</script>

<template>
  <div class="registration-card" @mouseenter="isHovering = true" @mouseleave="isHovering = false">
    <div class="icon">
      <slot name="icon" v-bind="{isHovering}"></slot>
    </div>
    <div class="main-title">
      <div class="subtitle">
        <slot name="subtitle" v-bind="{isHovering}"></slot>
      </div>
      <div class="title">
        <slot name="title" v-bind="{isHovering}"></slot>
      </div>
    </div>
    <div class="description" v-balance-text.children>
      <slot name="description" v-bind="{isHovering}"></slot>
    </div>
    <div class="actions">
      <slot name="actions" v-bind="{isHovering}"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.registration-card {
  background-color: hsla(0, 0%, 100%, 1);
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.37, 0.42, 0.35, 0.88);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 100px repeat(3, 1fr);
  width: 100%;
  height: 100%;
  border: 1px solid hsla(0, 0%, 73%, 1);
  border-radius: 4px;
  padding: 28px 24px 36px 24px;
  backface-visibility: hidden;
  perspective: 1000px;

  &:hover {
    transform: translateY(-8px) translateZ(0);
    box-shadow: 0px 7px 12px 0px rgba(0, 0, 0, 0.24);
    background-color: hsla(354, 80%, 48%, 1);
    animation: bobble 3s infinite;
    animation-delay: 3s;

    .subtitle,
    .title,
    .description {
      color: hsla(0, 0%, 100%, 1);
    }

    .actions button.v-btn {
      background-color: hsla(0, 0%, 100%, 1) !important;
      color: hsla(354, 80%, 48%, 1) !important;
    }
  }

  .icon {
    position: relative;
    margin: auto auto 24px auto;
  }

  .main-title {
    place-items: start;
    margin-bottom: 24px;
  }

  .title {
    font-family: 'ProximaNovaExCnSbold', sans-serif !important;
    font-size: 20px;
    line-height: 1.3;
    text-align: center;
    color: hsla(354, 80%, 48%, 1);
    text-transform: uppercase;

    transition: all 0.3s;
    transition-timing-function: cubic-bezier(0.37, 0.42, 0.35, 0.88);
  }

  .subtitle {
    font-family: 'ProximaNovaExCnSbold', sans-serif;
    font-size: 20px;
    line-height: 1.3;
    text-align: center;
    color: hsla(0, 0%, 13%, 1);
    text-transform: uppercase;
    transition: all 0.3s;
    transition-timing-function: cubic-bezier(0.37, 0.42, 0.35, 0.88);
  }

  .description {
    font-family: 'ProximaNovaRegular', sans-serif;
    font-size: 14px;
    line-height: 1.2;
    text-align: center;
    color: hsla(0, 0%, 33%, 1);
    transition: all 0.3s;
    transition-timing-function: cubic-bezier(0.37, 0.42, 0.35, 0.88);
  }

  .actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: auto;

    button {
      transition: all 0.3s;
      transition-timing-function: cubic-bezier(0.37, 0.42, 0.35, 0.88);
    }
  }
}

@keyframes bobble {
  0% {
    transform: translateY(-8px);
    box-shadow: 0px 7px 12px 0px rgba(0, 0, 0, 0.24);
  }

  50% {
    transform: translateY(-2px);
    box-shadow: 0px 2px 4px 0px hsla(0, 0%, 0%, 0.24);
  }

  100% {
    transform: translateY(-8px);
    box-shadow: 0px 7px 12px 0px rgba(0, 0, 0, 0.24);
  }
}
</style>
